module.exports = __webpack_public_path__ + "img/devices@2x.7c96ca81.png";